import React, {useMemo, useState} from 'react'
import OrderModal from 'app/features/orders/componentsv1/view/orderModal/OrderModal'
import {EditOrderNotes} from 'app/features/orders/componentsv1/shared/Notes'
import CustomerNewNoteEdit from './CustomerNewNote'
import CustomerNewNote from 'app/features/orders/componentsv1/view/CustomerNewNote'

interface Props {
  onClose: () => void
  notes: any
  isEditable?: boolean
}

export const CustomerNoteDialog: React.FC<Props> = ({onClose, notes, isEditable}) => {
  const [showNote, setShowNote] = useState(false)
  const [note, setNote] = useState(null)

  return useMemo(() => {
    const handleNoteAdd = () => {
      setShowNote(true)
    }

    const handleShowNote = (note: any) => {
      setNote(note)
      handleNoteAdd()
    }

    const handleCloseNote = () => {
      setNote(null)
      setShowNote(false)
    }

    if (showNote) {
      if (isEditable) {
        return <CustomerNewNoteEdit onClose={handleCloseNote} value={note} />
      }
      return <CustomerNewNote onClose={handleCloseNote} value={note} />
    }

    return (
      <OrderModal
        btnText='Add Note'
        title='Notes'
        onClose={onClose}
        icon='notes'
        onConfirm={handleNoteAdd}
        showModelHeader
      >
        <EditOrderNotes notes={notes} onClick={handleShowNote} isEditable={isEditable} />
      </OrderModal>
    )
  }, [note, notes, onClose, showNote])
}

export default CustomerNoteDialog
